import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { GraduationCap, Package, Radio, Gavel, Wallet } from 'lucide-react';

const isFile = (u) => /\.(mp4|webm)(\?|$)/i.test(u);
const embed = (url) => {
  if (url.includes('/embed/')) return url;
  const y = url.match(/(?:youtu\.be\/|v=|shorts\/)([\w-]{11})/);
  if (y) return `https://www.youtube.com/embed/${y[1]}`;
  return url;
};
const STEPS = [
  { icon: Package, title: 'Crée ta boutique et ajoute tes produits', sub: 'Onglet « Ma boutique & mes produits » : nom, ville, puis « Ajouter un produit » (photos, prix, stock).' },
  { icon: Radio, title: 'Lance ton live', sub: 'Crée le live puis « Démarrer la diffusion » avec ta caméra.' },
  { icon: Gavel, title: 'Ouvre l\'enchère', sub: 'Choisis l\'article, le palier et la durée. Le chrono fait le reste.' },
  { icon: Wallet, title: 'Encaisse et confirme', sub: 'La gagnante paie par Wave / Orange Money, tu confirmes puis tu livres.' },
];

export function SellerTutorial() {
  const [video, setVideo] = useState('/guide.mp4');
  const [open, setOpen] = useState(() => localStorage.getItem('ssl_tuto_hidden') !== '1');
  useEffect(() => { api.get('/settings/public').then(({ data }) => setVideo(data.tutorial_video_url || '/guide.mp4')).catch(() => {}); }, []);
  const toggle = () => { localStorage.setItem('ssl_tuto_hidden', open ? '1' : '0'); setOpen(!open); };
  return (
    <section className="card-elev rounded-2xl p-5" data-testid="seller-tutorial">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-display text-xl font-bold flex items-center gap-2"><GraduationCap className="h-5 w-5 text-sky-400" />Guide vidéo : inscription, vente, achat (avec voix)</h2>
        <button onClick={toggle} data-testid="seller-tutorial-toggle" className="text-xs text-slate-400 hover:text-white">{open ? 'Masquer' : 'Afficher'}</button>
      </div>
      {open && (
        <div className="mt-4 grid lg:grid-cols-[1fr_320px] gap-5">
          <div className="aspect-video rounded-2xl overflow-hidden border border-white/10 bg-slate-900" data-testid="seller-tutorial-video">
            {isFile(video) ? (
              <video data-testid="seller-tutorial-player" controls playsInline preload="metadata" poster="/og-image.png" className="w-full h-full object-cover">
                <source src={video} type={video.endsWith('.webm') ? 'video/webm' : 'video/mp4'} />
              </video>
            ) : (
              <iframe src={embed(video)} title="Tutoriel vendeuse" className="w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
            )}
          </div>
          <ol className="space-y-2">
            {STEPS.map(({ icon: Icon, title, sub }, i) => (
              <li key={title} className="flex gap-3 rounded-xl bg-slate-900/50 border border-slate-800 p-3" data-testid={`tuto-step-${i + 1}`}>
                <div className="h-9 w-9 shrink-0 rounded-full btn-brand grid place-items-center text-white"><Icon className="h-4 w-4" /></div>
                <div><div className="font-bold text-sm">{i + 1}. {title}</div><div className="text-xs text-slate-400">{sub}</div></div>
              </li>
            ))}
          </ol>
        </div>
      )}
    </section>
  );
}
